export const isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
export const isAndroid = /(Android)/i.test(navigator.userAgent);
